import React from 'react';
import Checkbox from 'material-ui/Checkbox';

import { styles } from './styles';

const MapViewHeader = ({
  ungroupMapPins,
  onGroupPinChange,
  hasData,
}) => {
  return (
    <div className="map-view-header" style={styles.header}>
      <div className="map-view-header-checkbox">
        {hasData && (
          <Checkbox
            label="Show Slates Grouped"
            checked={!ungroupMapPins}
            onCheck={onGroupPinChange}
            labelStyle={styles.checkboxLabel}
            iconStyle={styles.checkboxIcon}
          />
        )}
      </div>
    </div>
  );
};

export default MapViewHeader;
